module.exports = __webpack_public_path__ + "img/按钮2.606886e4.png";